// Données éditoriales des pages locales EDL-EXPRESS.
// Contenu rédigé à la main pour chaque commune — pas de texte générique copié-collé.
// Règles : uniquement des faits génériques sûrs (bâti, dessertes connues) ;
// aucun chiffre, aucune adresse, aucune agence inventée.

export const CITIES = [
  {
    slug: "lyon",
    name: "Lyon",
    title: "État des lieux à Lyon | Entrée & sortie — EDL-EXPRESS",
    meta: "État des lieux d'entrée et de sortie à Lyon (Presqu'île, Croix-Rousse, Part-Dieu, Confluence…) : rapport numérique ImmoPad avec photos, pour agences, propriétaires et conciergeries. Déplacement inclus dans la zone prioritaire de 10 km autour de Bron.",
    lead: "Du studio de la Croix-Rousse aux résidences récentes de Confluence, EDL-EXPRESS réalise à Lyon des états des lieux d'entrée et de sortie complets : chaque pièce décrite, chaque point notable photographié, un dossier numérique ImmoPad exploitable dès sa réception. Nous intervenons directement dans le logement, pour les agences, administrateurs de biens, propriétaires et conciergeries.",
    context: [
      {
        title: "Un parc qui traverse les époques",
        text: "Entre les immeubles du Vieux-Lyon, les façades de la Presqu'île, les ensembles de la Part-Dieu et les programmes récents de Confluence, aucun état des lieux à Lyon ne ressemble au précédent : matériaux, équipements et finitions changent complètement d'un bail à l'autre. Notre méthode photo systématique documente aussi bien les rendus sur matériaux anciens que les finitions du neuf.",
      },
      {
        title: "Une pression locative qui pardonne peu",
        text: "La demande de logements est forte et les transitions se jouent vite : entre deux locataires, le moindre flou dans le rapport peut coûter une retenue de caution mal étayée ou une contestation. Un dossier daté, photographié et structuré sécurise autant le propriétaire que le locataire sortant.",
      },
      {
        title: "Des dessertes qui nous font gagner du temps",
        text: "Métros A, B, C et D, tramways, gares de la Part-Dieu et de Perrache : nous enchaînons les rendez-vous dans les arrondissements sans perte de temps, y compris pour les interventions urgentes sous 24 h (option +20 €).",
      },
    ],
    quartiers:
      "Presqu'île · Croix-Rousse · Part-Dieu · Confluence · Vieux-Lyon · Gerland · 8e arrondissement… nous couvrons les neuf arrondissements de Lyon.",
    prestations: [
      {
        title: "Entrée des lieux à Lyon",
        text: "Relevé pièce par pièce, état des équipements, sols et murs, comptage des clés et badges, photos de chaque surface : le point de départ net et daté du bail.",
      },
      {
        title: "Sortie des lieux à Lyon",
        text: "Le même niveau de détail, comparé point par point à l'entrée du logement : c'est ce rapprochement détaillé et documenté qui limite les contestations sur la retenue de caution.",
      },
      {
        title: "Dossier numérique ImmoPad",
        text: "Rapport détaillé réalisé sous ImmoPad, avec photos intégrées : un PDF lisible par toutes les parties, transmissible aux agences, syndics et assureurs.",
      },
      {
        title: "Options utiles en centre-ville",
        text: "Garage, cave ou annexe simple (+10 €), inventaire meublé très détaillé (+20 à +40 €), sortie le même jour (-30 %), intervention urgente sous 24 h (+20 €).",
      },
    ],
    faq: [
      {
        q: "Le déplacement à Lyon est-il facturé ?",
        a: "Non pour la majorité de la ville : nos frais de déplacement sont inclus dans un rayon de 10 km autour de Bron, ce qui couvre la Presqu'île, la Croix-Rousse, la Part-Dieu, Gerland et la Confluence. Au-delà, +0,80 €/km aller-retour avec un minimum de 15 €.",
      },
      {
        q: "Travaillez-vous avec les agences immobilières lyonnaises ?",
        a: "Oui : agences, administrateurs de biens et conciergeries nous confient leurs entrées et sorties. Nous suivons leurs protocoles et leur renvoyons un dossier prêt à archiver.",
      },
      {
        q: "Que se passe-t-il si le locataire ne peut pas être présent ?",
        a: "L'état des lieux reste valable : nous réalisons le relevé complet et le transmettons aux parties concernées. Prévenez-nous simplement en amont pour organiser l'accès au logement.",
      },
    ],
  },
  {
    slug: "villeurbanne",
    name: "Villeurbanne",
    title: "État des lieux à Villeurbanne | Entrée & sortie — EDL-EXPRESS",
    meta: "État des lieux d'entrée et de sortie à Villeurbanne (Charpennes, Tonkin, Grange Blanche…) : rapport numérique ImmoPad avec photos, pour agences, propriétaires et conciergeries. Déplacement inclus dans la zone prioritaire de 10 km autour de Bron.",
    lead: "Deuxième ville de la Métropole et grand campus, Villeurbanne concentre de nombreux studios et T2 qui changent de locataire au rythme des années scolaires. EDL-EXPRESS y réalise des états des lieux d'entrée et de sortie méthodiques, documentés sous ImmoPad avec photos — le meilleur rempart face aux rotations répétées.",
    context: [
      {
        title: "Une ville universitaire qui tourne vite",
        text: "Autour de la Doua, de Charpennes et de Grange Blanche, les logements se succèdent d'un locataire à l'autre au fil des années scolaires. Chaque entrée et chaque sortie doit donc être irréprochable : c'est elle qui fait foi quand la caution se joue entre deux rentrées.",
      },
      {
        title: "Un parc mêlé : ancien, grandes copropriétés et résidences récentes",
        text: "Les résidences des années 60-70 du Tonkin ou de Grandcamp n'ont pas les mêmes points de vigilance que les immeubles plus anciens ou les programmes neufs. Nous adaptons notre relevé à chaque type de bâti, équipements compris.",
      },
      {
        title: "Facile à desservir, donc à planifier",
        text: "Métro B à Charpennes, tramways T3 et T4, bus du réseau TCL : Villeurbanne est à quelques minutes de notre base de Bron, avec déplacement inclus dans la zone prioritaire de 10 km.",
      },
    ],
    quartiers:
      "Charpennes · Tonkin · Grange Blanche · Grandcamp · Cusset · Saint-Jean · Les Brosses… toute la ville est dans notre zone de déplacement inclus.",
    prestations: [
      {
        title: "Entrée des lieux à Villeurbanne",
        text: "Idéale pour poser un état de référence net avant une location étudiante : pièces, équipements, sols, murs, compteurs et clés, tout est photographié et consigné.",
      },
      {
        title: "Sortie des lieux à Villeurbanne",
        text: "Point par point face à l'entrée : c'est ce qui distingue une usure normale d'une dégradation imputable, avec les photos pour appuyer chaque constat.",
      },
      {
        title: "Rapport numérique ImmoPad",
        text: "Dossier détaillé avec photos intégrées, lisible et facile à transmettre — précieux quand les parties vivent dans des villes différentes.",
      },
      {
        title: "Options adaptées aux petites surfaces",
        text: "Inventaire meublé très détaillé (+20 à +40 €) pour les studios équipés, annexe simple (+10 €) pour cave ou parking, intervention urgente sous 24 h (+20 €).",
      },
    ],
    faq: [
      {
        q: "Intervenez-vous pendant la période de rentrée universitaire ?",
        a: "Oui, c'est l'une des périodes les plus denses de l'année : nous conseillons de réserver les créneaux dès la confirmation du bail. L'option urgence sous 24 h (+20 €) existe pour les imprévus.",
      },
      {
        q: "Le déplacement à Villeurbanne est-il inclus ?",
        a: "Oui : la ville est entièrement dans la zone prioritaire de 10 km autour de Bron, aucun frais de déplacement ne s'applique.",
      },
      {
        q: "Pouvez-vous gérer l'entrée et la sortie du même locataire ?",
        a: "Oui : en réservant l'entrée et la sortie du même logement, vous bénéficiez de -15 % sur l'état des lieux de sortie (offre fidélité, appliquée au tarif en vigueur au moment de la sortie).",
      },
    ],
  },
  {
    slug: "bron",
    name: "Bron",
    title: "État des lieux à Bron | Notre ville de base — EDL-EXPRESS",
    meta: "État des lieux d'entrée et de sortie à Bron, notre ville de base : déplacement inclus dans la zone prioritaire de 10 km, rapport numérique ImmoPad avec photos pour agences, propriétaires et conciergeries.",
    lead: "Bron, c'est notre ville de base : nous y intervenons en priorité et le déplacement y est inclus dans toute la zone prioritaire de 10 km. Maisons des Maisons Neuves, copropriétés du centre, résidences proches du Parilly : nous connaissons le bâti et nous réalisons des états des lieux d'entrée et de sortie complets, avec photos, sous ImmoPad.",
    context: [
      {
        title: "Notre base, vos déplacements inclus",
        text: "Nos frais de déplacement sont offerts dans un rayon de 10 km autour du Lycée Professionnel de Bron : tout le territoire communal est couvert, sans supplément, pour les entrées comme pour les sorties.",
      },
      {
        title: "Un bâti varié, des annexes fréquentes",
        text: "Maisons individuelles, copropriétés des années 60-70, résidences récentes : à Bron, beaucoup de logements s'accompagnent d'une cave, d'un garage ou d'un box. Ces annexes entrent dans le relevé, avec l'option annexe simple à +10 € par annexe quand il y en a plusieurs.",
      },
      {
        title: "Un maillage complet",
        text: "Accès A43, tramways T2 et T4, proximité des hôpitaux : nous intervenons facilement et vite à Bron, y compris en urgence sous 24 h (+20 €).",
      },
    ],
    quartiers:
      "Centre-ville · Les Maisons Neuves · Parilly · secteurs proches du CHU Louis Pradel et de l'avenue Fleming… toute la commune est dans notre zone de déplacement inclus.",
    prestations: [
      {
        title: "Entrée et sortie des lieux à Bron",
        text: "Le duo complet, au même niveau de soin : relevé détaillé pièce par pièce, photos de chaque point notable, équipements et clés consignés.",
      },
      {
        title: "Sortie documentée à fond",
        text: "Chaque point de la sortie est confronté aux photos de l'entrée : c'est la comparaison qui protège le bailleur comme le locataire lors de la restitution de caution.",
      },
      {
        title: "Dossier numérique ImmoPad",
        text: "Rapport détaillé sous ImmoPad avec photos intégrées, transmissible directement à l'agence, au syndic ou à l'assureur.",
      },
      {
        title: "Relevé compteurs et remise de clés",
        text: "En complément d'une visite ou seul : relevé des compteurs et remise de clés pour 29 €, pratique lors d'un changement de locataire.",
      },
    ],
    faq: [
      {
        q: "Pourquoi le déplacement est-il gratuit à Bron ?",
        a: "Parce que Bron est notre ville de base : nos frais de déplacement sont inclus dans un rayon de 10 km autour du Lycée Professionnel de Bron, comme indiqué dans nos tarifs.",
      },
      {
        q: "Mon pavillon a un garage et une cave : comment sont-ils traités ?",
        a: "Ils sont intégrés au relevé. Si vous souhaitez les documenter en détail, l'option annexe simple s'applique à +10 € par annexe.",
      },
      {
        q: "Vous êtes basés où exactement ?",
        a: "À Bron même : c'est là que tout part, et c'est ce qui fait notre réactivité pour les entrées comme pour les sorties.",
      },
    ],
  },
  {
    slug: "vaulx-en-velin",
    name: "Vaulx-en-Velin",
    title: "État des lieux à Vaulx-en-Velin | Entrée & sortie — EDL-EXPRESS",
    meta: "État des lieux d'entrée et de sortie à Vaulx-en-Velin (Grand Large, Mas des Bruyères…) : rapport numérique ImmoPad avec photos, pour agences, propriétaires et conciergeries. Déplacement inclus dans la zone prioritaire de 10 km autour de Bron.",
    lead: "Entre les résidences rénovées du Grand Large et les programmes récents du pôle de La Soie, Vaulx-en-Velin a vu son parc changer vite. EDL-EXPRESS y documente chaque entrée et chaque sortie avec la même grille exigeante : pièces, équipements, photos, dossier numérique ImmoPad remis rapidement.",
    context: [
      {
        title: "Un parc transformé par la rénovation urbaine",
        text: "Réhabilitations d'ampleur au Mas des Bruyères, nouveau quartier du Grand Large : beaucoup de logements ont été refaits ces dernières années. Bien décrire l'état réel au moment du bail évite de confondre une vétusté assumée avec une dégradation récente.",
      },
      {
        title: "Des équipements à passer au crible",
        text: "Dans les logements rénovés ou relogés, chauffage, ventilation et équipements de cuisine méritent d'être notés précisément à l'entrée pour être suivis à la sortie. C'est le cœur de notre relevé.",
      },
      {
        title: "À deux pas de notre base",
        text: "Métro A à La Soie, tramway T3, accès rapide depuis Bron : Vaulx-en-Velin est entièrement dans notre zone de déplacement inclus.",
      },
    ],
    quartiers:
      "Grand Large · Mas des Bruyères · Pôle d'échanges de La Soie · centre-ville… toute la commune est dans notre zone de déplacement inclus.",
    prestations: [
      {
        title: "Entrée des lieux à Vaulx-en-Velin",
        text: "Un état de référence précis, essentiel dans les logements rénovés : surfaces, équipements, compteurs et clés consignés et photographiés.",
      },
      {
        title: "Sortie des lieux à Vaulx-en-Velin",
        text: "Comparaison point par point avec l'entrée, photos à l'appui : le dossier qui permet de statuer sereinement sur la caution.",
      },
      {
        title: "Dossier numérique ImmoPad",
        text: "Rapport détaillé avec photos intégrées, structuré et lisible, prêt à archiver pour une agence ou un syndic.",
      },
      {
        title: "Options pour logements équipés",
        text: "Inventaire meublé très détaillé (+20 à +40 €), annexe simple (+10 €), sortie le même jour (-30 %), intervention urgente sous 24 h (+20 €).",
      },
    ],
    faq: [
      {
        q: "Logement rénové : faut-il un état des lieux plus détaillé ?",
        a: "Souvent oui, pour rendre compte des équipements récents. L'inventaire meublé très détaillé (+20 à +40 €) est particulièrement pertinent pour les logements équipés.",
      },
      {
        q: "Le déplacement est-il inclus à Vaulx-en-Velin ?",
        a: "Oui : la commune est dans la zone prioritaire de 10 km autour de Bron, aucun frais de déplacement ne s'applique.",
      },
      {
        q: "Avec qui travaillez-vous à Vaulx-en-Velin ?",
        a: "Propriétaires, agences et conciergeries : nous suivons les protocoles de chacun et remettons un dossier numérique prêt à l'emploi.",
      },
    ],
  },
  {
    slug: "venissieux",
    name: "Vénissieux",
    title: "État des lieux à Vénissieux | Entrée & sortie — EDL-EXPRESS",
    meta: "État des lieux d'entrée et de sortie à Vénissieux (Parilly, Moulin à Vent, Les Planeurs…) : rapport numérique ImmoPad avec photos, pour agences, propriétaires et conciergeries. Déplacement inclus dans la zone prioritaire de 10 km autour de Bron.",
    lead: "Entre le pavillonnaire de Parilly et les grands ensembles rénovés de Moulin à Vent, Vénissieux réunit des logements très différents — avec à chaque fois le même enjeu : un état des lieux d'entrée et de sortie précis, photographié, qui évite les contestations. EDL-EXPRESS intervient directement sur place, dossier numérique ImmoPad à l'appui.",
    context: [
      {
        title: "Deux mondes en une ville",
        text: "Maisons avec jardin près de Parilly, ensembles rénovés autour de Moulin à Vent, programmes récents côté Planeurs : les points de vigilance d'un état des lieux changent complètement d'un quartier à l'autre. Notre grille s'adapte à chacun.",
      },
      {
        title: "Des sorties à documenter précisément",
        text: "Dans les copropriétés nombreuses de la ville, la sortie est le moment décisif : chaque dégradation potentielle doit être confrontée aux photos de l'entrée. C'est exactement notre méthode.",
      },
      {
        title: "Rapide depuis notre base",
        text: "Métro D jusqu'à la gare de Vénissieux, tramway T4, accès direct depuis Bron : la commune est entièrement dans notre zone de déplacement inclus (10 km autour de Bron).",
      },
    ],
    quartiers:
      "Parilly · Moulin à Vent · Les Planeurs · centre-ville et secteur de la gare de Vénissieux… toute la commune est dans notre zone de déplacement inclus.",
    prestations: [
      {
        title: "Entrée des lieux à Vénissieux",
        text: "Relevé complet et photographié du logement, du studio au pavillon : la référence datée du bail, prête à être opposée si besoin.",
      },
      {
        title: "Sortie des lieux à Vénissieux",
        text: "Le même niveau de détail, point par point face à l'entrée : chaque écart est documenté par photo, sans interprétation.",
      },
      {
        title: "Dossier numérique ImmoPad",
        text: "Rapport détaillé sous ImmoPad, photos intégrées : un dossier unique, lisible par le bailleur, le locataire et l'agence.",
      },
      {
        title: "Prestations complémentaires",
        text: "Relevé des compteurs et remise de clés (29 €), annexe simple (+10 €), inventaire meublé très détaillé (+20 à +40 €), urgence sous 24 h (+20 €).",
      },
    ],
    faq: [
      {
        q: "Comment se déroule votre sortie des lieux ?",
        a: "Relevé complet pièce par pièce, comparaison avec l'état d'entrée, photos de chaque point notable, puis dossier numérique remis rapidement aux parties.",
      },
      {
        q: "Le déplacement à Vénissieux est-il facturé ?",
        a: "Non : la commune est dans la zone prioritaire de 10 km autour de Bron, le déplacement est inclus.",
      },
      {
        q: "Proposez-vous un relevé des compteurs ?",
        a: "Oui : notre prestation relevé de compteurs / remise de clés (29 €) peut être réalisée lors de la même visite ou seule.",
      },
    ],
  },
  {
    slug: "caluire-et-cuire",
    name: "Caluire-et-Cuire",
    title: "État des lieux à Caluire-et-Cuire | Entrée & sortie — EDL-EXPRESS",
    meta: "État des lieux d'entrée et de sortie à Caluire-et-Cuire : villas, maisons et résidences des hauteurs de Lyon, rapport numérique ImmoPad avec photos. Déplacement inclus dans la zone prioritaire de 10 km autour de Bron.",
    lead: "Posée sur les hauteurs au nord de Lyon, Caluire-et-Cuire est une ville de maisons : villas, maisonnettes et résidences calmes à flanc de colline. EDL-EXPRESS y documente chaque entrée et chaque sortie avec la même rigueur — et une attention particulière aux annexes et extérieurs qui font la valeur d'un bien.",
    context: [
      {
        title: "Une ville de maisons et de villas",
        text: "Caluire-et-Cuire compte peu de grands ensembles et beaucoup de logements individuels ou de petites copropriétés. Chaque visite exige un relevé complet : dépendances, extérieurs, accès — tout ce qui distingue ces biens des appartements standards.",
      },
      {
        title: "Des extérieurs qui comptent dans le bail",
        text: "Jardin, terrasse, sous-sol, garage : quand ces espaces font partie du contrat de location, leur état doit être consigné à l'entrée autant qu'à la sortie. L'option annexe simple (+10 €) est justement prévue pour cela.",
      },
      {
        title: "Proche de tout, sans y perdre de temps",
        text: "Métro C jusqu'à Cuire, bus du réseau TCL et accès rapides vers la Croix-Rousse : la commune est dans notre zone de déplacement inclus (10 km autour de Bron).",
      },
    ],
    quartiers:
      "Cuire · Saint-Clair · Montessuy · Vassieux · les hauteurs côté Croix-Rousse… toute la commune est dans notre zone de déplacement inclus.",
    prestations: [
      {
        title: "Entrée et sortie à Caluire-et-Cuire",
        text: "Maison, villa ou appartement : relevé pièce par pièce, photos de chaque surface, compteurs et clés consignés.",
      },
      {
        title: "Extérieurs et annexes documentés",
        text: "Jardins, terrasses, garages, caves et sous-sols intégrés au relevé, avec l'option annexe simple (+10 €) quand il y en a plusieurs.",
      },
      {
        title: "Dossier numérique ImmoPad",
        text: "Rapport détaillé avec photos, structuré pour être archivé par une agence ou opposé en cas de litige.",
      },
      {
        title: "Prestations complémentaires",
        text: "Relevé des compteurs et remise de clés (29 €), inventaire meublé très détaillé (+20 à +40 €), intervention urgente sous 24 h (+20 €).",
      },
    ],
    faq: [
      {
        q: "Mon bien a un jardin et un sous-sol : comment sont-ils traités ?",
        a: "Ils font partie du relevé ; si vous souhaitez leur documentation complète, l'option annexe simple (+10 € par annexe) s'applique.",
      },
      {
        q: "Le déplacement à Caluire-et-Cuire est-il facturé ?",
        a: "Non : la commune est dans le rayon de 10 km autour de Bron, le déplacement est inclus.",
      },
      {
        q: "Intervenez-vous pour une seule maison, sans agence intermédiaire ?",
        a: "Bien sûr : nous travaillons aussi directement avec les propriétaires, pour une entrée, une sortie ou le duo des deux (-15 % sur la sortie, offre fidélité).",
      },
    ],
  },
  {
    slug: "decines-charpieu",
    name: "Décines-Charpieu",
    title: "État des lieux à Décines-Charpieu | Entrée & sortie — EDL-EXPRESS",
    meta: "État des lieux d'entrée et de sortie à Décines-Charpieu : maisons, résidences récentes et logements côté Grand Parc de Miribel-Jonage. Rapport numérique ImmoPad avec photos, déplacement inclus autour de Bron.",
    lead: "À l'est de la Métropole, Décines-Charpieu mêle pavillons, résidences récentes et programmes qui poussent côté Grand Parc de Miribel-Jonage. EDL-EXPRESS y intervient directement dans les logements pour des états des lieux d'entrée et de sortie complets, documentés sous ImmoPad.",
    context: [
      {
        title: "Un parc qui grandit vers l'est",
        text: "Résidences récentes, lotissements et petites copropriétés : beaucoup de logements sont récents ou bien entretenus, et c'est précisément là qu'un état des lieux minutieux protège la valeur du bien.",
      },
      {
        title: "Entre lac et stade, des locataires qui bougent",
        text: "Proximité du Grand Parc de Miribel-Jonage et du Groupama Stadium : la ville attire et les logements tournent. Une entrée photographiée précise évite les zones grises à la sortie.",
      },
      {
        title: "Desservie par le tram T3",
        text: "Le tramway T3 relie la ville à Lyon et à notre base de Bron en un rien de temps : déplacement inclus dans la zone prioritaire de 10 km.",
      },
    ],
    quartiers:
      "Centre-ville · secteurs du Grand Parc de Miribel-Jonage · secteurs proches du Groupama Stadium… toute la commune est dans notre zone de déplacement inclus.",
    prestations: [
      {
        title: "Entrée des lieux à Décines-Charpieu",
        text: "L'état de référence daté du bail : pièces, équipements, photos, clés et compteurs consignés.",
      },
      {
        title: "Sortie des lieux à Décines-Charpieu",
        text: "Comparaison systématique avec l'entrée, photos de chaque point notable : le dossier qui départage usure et dégradation.",
      },
      {
        title: "Dossier numérique ImmoPad",
        text: "PDF structuré avec photos intégrées, transmissible à l'agence, au syndic ou à l'assureur.",
      },
      {
        title: "Options pour biens récents et équipés",
        text: "Inventaire meublé très détaillé (+20 à +40 €), annexe simple (+10 €), sortie le même jour (-30 %), urgence sous 24 h (+20 €).",
      },
    ],
    faq: [
      {
        q: "Logement récent : l'état des lieux change-t-il ?",
        a: "La méthode reste la même, le niveau de détail augmente : équipements, finitions et annexes méritent d'être notés précisément à l'entrée.",
      },
      {
        q: "Le déplacement à Décines-Charpieu est-il inclus ?",
        a: "Oui : la commune est dans le rayon de 10 km autour de Bron.",
      },
      {
        q: "Pouvez-vous intervenir pour plusieurs logements d'un même propriétaire ?",
        a: "Oui : agences, conciergeries et propriétaires multi-biens nous confient leurs rotations ; nous organisons les visites en série.",
      },
    ],
  },
  {
    slug: "meyzieu",
    name: "Meyzieu",
    title: "État des lieux à Meyzieu | Entrée & sortie — EDL-EXPRESS",
    meta: "État des lieux d'entrée et de sortie à Meyzieu : maisons individuelles, pavillons et résidences à l'est de la Métropole de Lyon, rapport numérique ImmoPad avec photos. Déplacement inclus dans la zone prioritaire de 10 km autour de Bron.",
    lead: "Meyzieu, c'est le grand est résidentiel : beaucoup de maisons, des pavillons entretenus, des résidences familiales. EDL-EXPRESS y réalise des états des lieux d'entrée et de sortie maison par maison, avec le même dossier numérique ImmoPad que pour nos autres communes.",
    context: [
      {
        title: "Maison par maison, pas de standard",
        text: "Chaque pavillon a ses équipements, ses annexes et ses particularités : notre relevé s'adapte au bien, pas l'inverse. Les photos font le reste.",
      },
      {
        title: "Des annexes courantes dans le parc",
        text: "Garages, caves, abris et jardins accompagnent la plupart des logements : ils entrent au relevé, et l'option annexe simple (+10 €) permet de les documenter en détail.",
      },
      {
        title: "Le tram T3 jusqu'à nous",
        text: "Meyzieu est desservie par le tramway T3 et reste à moins de 10 km de notre base de Bron : déplacement inclus.",
      },
    ],
    quartiers:
      "Centre-ville · secteurs du Grand Parc de Miribel-Jonage · lotissements de l'est… toute la commune est dans notre zone de déplacement inclus.",
    prestations: [
      {
        title: "Entrée des lieux à Meyzieu",
        text: "Le point de départ du bail, complet et photographié : du séjour au garage, rien n'est laissé de côté.",
      },
      {
        title: "Sortie des lieux à Meyzieu",
        text: "Chaque point est comparé à l'entrée, avec photos à l'appui : la base sereine pour régulariser la caution.",
      },
      {
        title: "Dossier numérique ImmoPad",
        text: "Rapport détaillé et structuré, photos intégrées, prêt à transmettre aux parties.",
      },
      {
        title: "Prestations complémentaires",
        text: "Relevé des compteurs et remise de clés (29 €), annexe simple (+10 €), inventaire meublé très détaillé (+20 à +40 €).",
      },
    ],
    faq: [
      {
        q: "Mon pavillon a plusieurs annexes : quel surcoût ?",
        a: "L'option annexe simple s'applique à +10 € par annexe documentée en détail (garage, cave…).",
      },
      {
        q: "Le déplacement à Meyzieu est-il facturé ?",
        a: "Non : la commune est dans le rayon de 10 km autour de Bron.",
      },
      {
        q: "À quel moment intervenir ?",
        a: "Idéalement entre deux baux, dès la confirmation du départ ou de l'arrivée. Pour les imprévus, l'option urgence sous 24 h (+20 €) existe.",
      },
    ],
  },
  {
    slug: "saint-priest",
    name: "Saint-Priest",
    title: "État des lieux à Saint-Priest | Entrée & sortie — EDL-EXPRESS",
    meta: "État des lieux d'entrée et de sortie à Saint-Priest : pavillons, résidences et logements de l'est lyonnais, rapport numérique ImmoPad avec photos. Déplacement inclus dans la zone prioritaire de 10 km autour de Bron.",
    lead: "Sur l'axe de l'A43, Saint-Priest vit vite : logements variés, locataires qui changent, rotations à suivre. EDL-EXPRESS y intervient directement dans les logements pour des états des lieux d'entrée et de sortie précis, photographiés et remis en dossier numérique ImmoPad.",
    context: [
      {
        title: "Un parc varié, des rotations suivies",
        text: "Pavillons anciens, résidences des décennies récentes, programmes neufs : chaque type de bien a ses points de vigilance, et chaque bail mérite un état de référence net.",
      },
      {
        title: "Entre ville et champs",
        text: "Proche du parc de Parilly et des grands axes, la ville attire des locataires de profils très différents : les photos datées du dossier font foi quand la situation se tend.",
      },
      {
        title: "À l'est, mais à côté",
        text: "Tram T2 vers Lyon, accès A43/A46 : Saint-Priest est à quelques minutes de notre base de Bron, déplacement inclus.",
      },
    ],
    quartiers:
      "Centre ancien · secteurs proches du parc de Parilly · lotissements de l'est… toute la commune est dans notre zone de déplacement inclus.",
    prestations: [
      {
        title: "Entrée des lieux à Saint-Priest",
        text: "Relevé complet et photographié du logement, du T2 au pavillon.",
      },
      {
        title: "Sortie des lieux à Saint-Priest",
        text: "Point par point face à l'entrée : chaque écart documenté, sans interprétation.",
      },
      {
        title: "Dossier numérique ImmoPad",
        text: "Rapport détaillé avec photos intégrées, transmis sous 24 heures maximum, sous réserve des vérifications nécessaires.",
      },
      {
        title: "Offre fidélité et options",
        text: "Entrée + sortie réservés ensemble : -15 % sur la sortie (au tarif en vigueur), sortie le même jour (-30 %), intervention urgente sous 24 h (+20 €).",
      },
    ],
    faq: [
      {
        q: "Le déplacement à Saint-Priest est-il inclus ?",
        a: "Oui : la commune est dans le rayon de 10 km autour de Bron.",
      },
      {
        q: "Proposez-vous l'entrée et la sortie en pack ?",
        a: "Oui : en réservant l'entrée et la sortie du même logement, -15 % s'applique sur votre état des lieux de sortie (offre fidélité, au tarif en vigueur au moment de la sortie).",
      },
      {
        q: "Comment est remis le rapport ?",
        a: "En dossier numérique ImmoPad, avec photos : lisible et archivable par toutes les parties.",
      },
    ],
  },
  {
    slug: "oullins-pierre-benite",
    name: "Oullins-Pierre-Bénite",
    title: "État des lieux à Oullins-Pierre-Bénite | Entrée & sortie — EDL-EXPRESS",
    meta: "État des lieux d'entrée et de sortie à Oullins-Pierre-Bénite : maisons de ville, résidences familiales et logements du sud lyonnais, rapport numérique ImmoPad avec photos. Déplacement inclus dans la zone prioritaire de 10 km autour de Bron.",
    lead: "Dans le prolongement direct de Lyon, Oullins-Pierre-Bénite enchaîne maisons de ville, résidences familiales et programmes récents au bord du Rhône. EDL-EXPRESS y documente chaque bail : entrée et sortie complètes, photos, dossier numérique ImmoPad.",
    context: [
      {
        title: "Des maisons de ville aux résidences récentes",
        text: "Le parc de la commune va des maisons familiales aux programmes récents côté Rhône : notre grille d'inspection s'adapte à chaque génération de bâti.",
      },
      {
        title: "Un sud lyonnais qui attire",
        text: "Métro B jusqu'à la gare d'Oullins, qualité de vie au bord du Rhône : les logements tournent et un état des lieux bien tenu évite les mauvaises surprises des deux côtés.",
      },
      {
        title: "Plus proche qu'on ne croit",
        text: "Depuis Bron, l'accès est direct : la commune est dans notre zone de déplacement inclus (10 km autour de Bron).",
      },
    ],
    quartiers:
      "Gare d'Oullins · centre d'Oullins · Pierre-Bénite et ses bords de Rhône… toute la commune est dans notre zone de déplacement inclus.",
    prestations: [
      {
        title: "Entrée des lieux à Oullins-Pierre-Bénite",
        text: "Relevé complet pièce par pièce, photos, équipements, compteurs et clés consignés.",
      },
      {
        title: "Sortie des lieux à Oullins-Pierre-Bénite",
        text: "Comparaison systématique avec l'entrée : le dossier qui sécurise la restitution de caution.",
      },
      {
        title: "Dossier numérique ImmoPad",
        text: "Rapport détaillé avec photos, structuré pour l'agence, le syndic ou le propriétaire.",
      },
      {
        title: "Options et prestations complémentaires",
        text: "Relevé des compteurs et remise de clés (29 €), annexe simple (+10 €), inventaire meublé très détaillé (+20 à +40 €).",
      },
    ],
    faq: [
      {
        q: "Le déplacement à Oullins-Pierre-Bénite est-il facturé ?",
        a: "Non : la commune est dans le rayon de 10 km autour de Bron, le déplacement est inclus.",
      },
      {
        q: "Intervenez-vous chez les conciergeries du sud lyonnais ?",
        a: "Oui : nous travaillons avec les conciergeries, agences et propriétaires, selon leurs protocoles.",
      },
      {
        q: "Une visite peut-elle inclure compteurs et remise de clés ?",
        a: "Oui : la prestation relevé des compteurs / remise de clés (29 €) peut être ajoutée à la visite.",
      },
    ],
  },
];
